/**
 * Event utilities
 */

/**
 * Generate a unique event ID
 * Format: evt_{timestamp}_{random}
 */
export function generateEventId(): string {
  return `evt_${Date.now()}_${Math.random().toString(36).slice(2, 9)}`;
}
